import { AMBER_400, BLUE, GRAYSCALE_200, GRAYSCALE_400, LIGHT_LAVENDER, LIGHT_YELLOW, WHITE } from '@jagad/ui/src/styles/colors'

export const KYC_LEVELS = [
    {
        primaryColor: GRAYSCALE_400,
        secondaryColor: WHITE,
        bannerColor: GRAYSCALE_200,
        level: 0,
        name: "Basic"
    },
    {
        primaryColor: AMBER_400,
        secondaryColor: LIGHT_YELLOW,
        bannerColor: LIGHT_YELLOW,
        level: 1,
        name: "Level 1"
    },
    {
        primaryColor: BLUE,
        secondaryColor: LIGHT_LAVENDER,
        bannerColor: LIGHT_LAVENDER,
        level: 2,
        name: "Level 2"
    }
]
